import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
//import "@angular/compiler";

if (environment.production) {
  enableProdMode();
  test();
}

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.log(err));

function test() {
  const a = 7;
  const b = 9;
  const sum = a + b;
}
